import { render, staticRenderFns } from "./imageSetting.vue?vue&type=template&id=0593bf72&scoped=true"
import script from "./imageSetting.vue?vue&type=script&lang=ts"
export * from "./imageSetting.vue?vue&type=script&lang=ts"
import style0 from "./imageSetting.vue?vue&type=style&index=0&id=0593bf72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0593bf72",
  null
  
)

export default component.exports